import { PlanningParamsPayload } from "./types"

export type Action = GetPlanningParamsSuccessAction

export enum Types {
  SET = "PLANNING_PARAMS_SET",
}

export type GetPlanningParamsSuccessAction = {
  type: Types.SET
  payload: { data: PlanningParamsPayload }
}

export function setPlanningParams(data: PlanningParamsPayload): GetPlanningParamsSuccessAction {
  return {
    payload: { data },
    type: Types.SET,
  }
}
